import {
  NoDataLabel
} from "./chunk-K7SVS5D2.mjs";
import {
  isNullable
} from "./chunk-ARWLRO3D.mjs";

// lib/components/table/standard-table/components/no-data-filler.tsx
import { jsx } from "@emotion/react/jsx-runtime";
var NoDataFiller = (props) => {
  const { children } = props;
  const noDataCell = /* @__PURE__ */ jsx("td", { ...props, children: /* @__PURE__ */ jsx(NoDataLabel, {}) });
  if (isNullable(children)) {
    return noDataCell;
  }
  if (typeof children === "string") {
    if (/^\s*$/.test(children)) {
      return noDataCell;
    }
  }
  return /* @__PURE__ */ jsx("td", { ...props, children: props.children });
};

export {
  NoDataFiller
};
